import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';

import useLogInOut from '../../useLogInOut';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLogout',
  emits: ["doing-logout"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { isXS } = useMQBreakpoints();
const { refElem, logout } = useLogInOut();
const { loading: doingLogout, createPromise: logoutNow } = usePromise(logout);

const authLogout = () => logoutNow(isXS.value);

watch(
  doingLogout,
  () => {
    emit('doing-logout', doingLogout.value);
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refElem",
    ref: refElem,
    class: "auth-logout",
    onClick: authLogout
  }, _toDisplayString(_ctx.$t('modules.auth.logout')), 513))
}
}

})